import { getApiErrorMessage } from "./apierror";

/*export const gZipPost = (token, url, payload): Promise<string> => {
  const zlib = require("zlib");
  const axios = require("axios");
  return new Promise((resolve, reject) => {
    // Compress the data
    zlib.gzip(JSON.stringify(payload), (err, compressedData) => {
      if (err) {
        const x = err.message;
        reject(x);
        return;
      }
      // Send the compressed data
      axios
        .post(url, compressedData, {
          headers: { Authorization: `Bearer ${token}`, "Content-Encoding": "gzip", "Content-Type": "application/json" },
        })
        .then((response) => {
          console.log("Response:", response.data);
          return response.data.json();
        })
        .then(function (json) {
          resolve(json);
        })
        .catch((error) => {
          const x = error.message;
          reject(x);
        });
    });
  });
};*/

export const gZipPost = (token, url, payload): Promise<string> => {
  const pako = require("pako");
  const axios = require("axios");
  return new Promise((resolve, reject) => {

    const compressedData = pako.gzip(JSON.stringify(payload));

    axios
      .post(url, compressedData, {
        headers: { Authorization: `Bearer ${token}`, "Content-Encoding": "gzip", "Content-Type": "application/json" },
      })
      .then((response) => {

        resolve(response.data);
      })
      .catch((error) => {
        const x = error.message;
        resolve(error.message);
        reject(x);
      });
  });
};
const parseResponseBody = async (response: Response) => {
  const text = await response.text();
  if (!text) {
    return null;
  }
  try {
    return JSON.parse(text);
  } catch {
    return text;
  }
};

const createHttpError = (payload: any, status?: number, statusText?: string) => {
  const message =
    status === 404
      ? "No data found"
      : getApiErrorMessage(
          payload,
          `Request failed (${status || ""}${statusText ? " " + statusText : ""})`.trim()
        );
  const error: any = new Error(message);
  error.status = status;
  return error;
};

const handleHttpResponse = async (response: Response) => {
  const payload = await parseResponseBody(response);
  if (!response.ok) {
    throw createHttpError(payload, response.status, response.statusText);
  }
  return payload;
};

const rethrowHttpError = (error: any) => {
  throw createHttpError(error, error?.status);
};

export const get = (token, url): Promise<any> => {
  return fetch(url, {
    method: "get",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  })
    .then((response) => handleHttpResponse(response))
    .catch(rethrowHttpError);
};

export const post = (token, url, payload): Promise<any> => {
  return fetch(url, {
    method: "post",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  })
    .then((response) => handleHttpResponse(response))
    .catch(rethrowHttpError);
};
